/**
 * Created by piotr.pozniak@thebeaverhead.com on 22/11/2023.
 */

import axios from "axios";
import AxiosConfig from "../AxiosConfig";

export function fetchOrganization(uuid) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_FETCH" });

    const url = "/api/organizations/" + uuid + ".json";

    return axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}

export function editOrganization(uuid, data, isAdminRequest = false) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_EDIT", isAdminRequest });

    const url = "/api/organizations/" + uuid + ".json";

    return axios
      .put(url, data, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_EDIT_FULFILLED",
          payload: response.data,
          isAdminRequest,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_EDIT_REJECTED",
          payload: error,
          isAdminRequest,
        });
      });
  };
}

/**
 *
 * @param uuid
 * @param data
 * @param isAdminRequest
 * @returns {function(*): Promise<void>}
 */
export function createOrganization(data = false) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_CREATE" });

    const url = "/api/organizations.json";

    return axios
      .post(url, data, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_CREATE_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_CREATE_REJECTED",
          payload: error,
        });
      });
  };
}

export function fetchBillingHistory() {
  return function (dispatch) {
    dispatch({ type: "BILLING_HISTORY_FETCH" });

    const url = "/api/organizations/billing_history.json";

    return axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "BILLING_HISTORY_FETCH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "BILLING_HISTORY_FETCH_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @param uuid
 * @param data
 * @returns {function(*): Promise<AxiosResponse<any> | never>}
 */
export function editOrganizationSubscription(uuid, expiry) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_EDIT" });

    const url = "/api/subscriptions/edit_organization/" + uuid + ".json";

    return axios
      .put(
        url,
        {
          expiry,
        },
        AxiosConfig.getAuthConfig()
      )
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_EDIT_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_EDIT_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @param type
 * @param file
 * @returns {function(*): Promise<void>}
 */
export const uploadBrandingFile = (type, file) => {
  return (dispatch) => {
    dispatch({ type: "UPLOAD_BRANDING_FILE", fileType: type });

    const url = "/api/organizations/upload_branding_file.json";

    const formData = new FormData();
    formData.append("type", type);

    if (file instanceof File) {
      formData.append("file", file);
    }
    const config = AxiosConfig.getAuthConfig();
    config.headers["Content-Type"] = "multipart/form-data";

    return axios
      .post(url, formData, config)
      .then((response) => {
        dispatch({
          type: "UPLOAD_BRANDING_FILE_FULFILLED",
          fileType: type,
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "UPLOAD_BRANDING_FILE_REJECTED",
          fileType: type,
          payload: error,
        });
      });
  };
};

/**
 *
 * @param {Object} payload
 * @param {string} payload.role
 * @param {string} payload.industry
 * @param {string} payload.source
 * @returns {function(*): Promise<void>}
 */
export function activateTrial(payload) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_ACTIVATE_TRIAL" });

    const url = "/api/organizations/activate_trial.json";

    console.log("activateTrial payload", payload);
    return axios
      .post(url, payload, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_ACTIVATE_TRIAL_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_ACTIVATE_TRIAL_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @param {Object} payload
 * @param {string} payload.role
 * @param {string} payload.industry
 * @returns {function(*): Promise<void>}
 */
export function activateFreePlan(payload) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_ACTIVATE_FREE_PLAN" });

    const url = "/api/organizations/activate_free_plan.json";

    return axios
      .post(url, payload, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_ACTIVATE_FREE_PLAN_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_ACTIVATE_FREE_PLAN_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @param field
 * @param value
 * @returns {function(*): Promise<void>}
 */
export function updateOrgSetting(field, value) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_UPDATE_SETTING" });

    const url = "/api/organizations/update_setting.json";

    return axios
      .post(url, { field, value }, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_UPDATE_SETTING_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_UPDATE_SETTING_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @param uuid
 * @returns {function(*): Promise<void>}
 */
export function deleteOrganization(uuid) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_DELETE", uuid });

    const url = `/api/organizations/${uuid}.json`;

    return axios
      .delete(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_DELETE_FULFILLED",
          payload: response.data,
          uuid,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_DELETE_REJECTED",
          payload: error,
          uuid,
        });
      });
  };
}

/**
 *
 * @param {string} domainType
 * @param {string} value
 * @returns {function(*): Promise<void>}
 */
export function updateDomainSettings(domainType, value) {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_UPDATE_DOMAIN" });

    const url = "/api/organizations/set_domain.json";

    const data = {};

    switch (domainType) {
      case "default_domain":
        data.default_domain = true;
        break;
      case "subdomain":
        data.subdomain = value;
        break;
      case "custom":
        data.domain = value;
        break;
    }

    return axios
      .post(url, data, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_UPDATE_DOMAIN_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_UPDATE_DOMAIN_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @returns {function(*): Promise<void>}
 */
export function refreshDnsStatus() {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_DNS_REFRESH" });

    const url = "/api/organizations/check_dns.json";

    return axios
      .get(url, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_DNS_REFRESH_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_DNS_REFRESH_REJECTED",
          payload: error,
        });
      });
  };
}

/**
 *
 * @returns {function(*): Promise<void>}
 */
export function regenerateCertificate() {
  return function (dispatch) {
    dispatch({ type: "ORGANIZATION_CERT_REGENERATE" });

    const url = "/api/organizations/cert_regenerate.json";

    return axios
      .put(url, {}, AxiosConfig.getAuthConfig())
      .then((response) => {
        dispatch({
          type: "ORGANIZATION_CERT_REGENERATE_FULFILLED",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({
          type: "ORGANIZATION_CERT_REGENERATE_REJECTED",
          payload: error,
        });
      });
  };
}
